// src/components/profile/badgeConfig.js

// Map badge slugs to SVG filenames under /public/badges
const BADGE_SVGS = {
  alien_first_post: '/avatars/badges/alien_first_post.svg',
  alien_voted_bull_50: '/avatars/badges/alien_voted_bull_50.svg',
  alien_analyst_certified: '/avatars/badges/alien_analyst_certified.svg',
  alien_chart_wizard: '/avatars/badges/alien_chart_wizard.svg',
  alien_market_duelist: '/avatars/badges/alien_market_duelist.svg',
  alien_market_prophet: '/avatars/badges/alien_market_prophet.svg',
  alien_social_butterfly: '/avatars/badges/alien_social_butterfly.svg',
  alien_stonks_champion: '/avatars/badges/alien_stonks_champion.svg',
  alien_viral_star: '/avatars/badges/alien_viral_star.svg',
};

// Turn any badge id/name into a slug that matches BADGE_SVGS
export const slugifyBadge = (b) => {
  const raw = (b?.id || b?.name || '').toString().toLowerCase();
  let slug = raw
    .replace(/&/g, 'and')       // treat & as "and"
    .replace(/[^a-z0-9]+/g, '_')// collapse punctuation → _
    .replace(/^_|_$/g, '');     // trim _

  // normalize with "alien_" prefix
  if (!slug.startsWith('alien_')) {
    slug = `alien_${slug}`;
  }
  return slug;
};

// Return the SVG path for a badge if it exists
export const getBadgeSvg = (badge) => {
  const s = slugifyBadge(badge);

  if (BADGE_SVGS[s]) return BADGE_SVGS[s];

  // fallback: try partial fuzzy match
  const hit = Object.keys(BADGE_SVGS).find((k) => s.includes(k.replace(/^alien_/, '')));
  return hit ? BADGE_SVGS[hit] : null;
};